import maxLength from '../../../../v2/form/field-validation/max-length';
import required from '../../../../v2/form/field-validation/required';

const fieldName = 'fullName';

const getFullNameFieldDefinition = () => ({
  name: fieldName,
  label: 'checkout.delivery.address.field.label.name.text',
  required: true,
  validate: [required(fieldName), maxLength(35)],
  maxLength: 35,
  autoComplete: 'name',
});

export default getFullNameFieldDefinition;
